import Checkbox from '@mui/material/Checkbox'
import styled from 'styled-components'
import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'

const StyledCheckbox = styled(Checkbox)`
    color: ${ThemeColorsHospitalic.TEXT_PRIMARY};
`

export default StyledCheckbox